import { StreamLanguage } from "@codemirror/language";

// Custom DSL language mode for diagram syntax highlighting
const dslLanguage = StreamLanguage.define({
  name: "diagram-dsl",
  
  token(stream, state) {
    // Skip whitespace
    if (stream.eatSpace()) return null;
    
    // Comments
    if (stream.match(/\/\/.*/)) return "comment";
    if (stream.match(/%%.*/)) return "comment";
    
    // Keywords for different diagram types
    if (stream.match(/^(graph|flowchart|sequence|class|gantt|kanban|quadrant|requirements|journey|erDiagram|stateDiagram|pie|mindmap)\b/i)) {
      return "keyword";
    }
    
    // Direction keywords
    if (stream.match(/^(TD|TB|BT|RL|LR)\b/)) {
      return "keyword";
    }
    
    // Subgraph keywords
    if (stream.match(/^(subgraph|end)\b/)) {
      return "keyword";
    }
    
    // Section/title keywords
    if (stream.match(/^(section|title|x-axis|y-axis|quadrant-1|quadrant-2|quadrant-3|quadrant-4)\b/)) {
      return "keyword";
    }
    
    // Class diagram keywords
    if (stream.match(/^(class|interface|abstract|enum)\b/)) {
      return "keyword";
    }
    
    // Requirements keywords
    if (stream.match(/^(req|requirement|id|priority|status|high|medium|low|approved|pending|planned)\b/)) {
      return "keyword";
    }
    
    // Column keyword for kanban
    if (stream.match(/^column\b/)) {
      return "keyword";
    }
    
    // Arrow types - solid
    if (stream.match(/-->|-->>|->|==>|-.->|-\.->/)) {
      return "operator";
    }
    
    // Arrow types - dashed return
    if (stream.match(/-->>|<-->>|<--|<-/)) {
      return "operator";
    }
    
    // Relationship arrows for class/requirements
    if (stream.match(/<\|--|<\|\.\.|\*--|o--|-->/)) {
      return "operator";
    }
    
    // Relationship keywords
    if (stream.match(/- (derives|contains|depends|refines|traces|satisfies|verifies|copies) ->/)) {
      return "keyword";
    }
    
    // Labels in pipes |text|
    if (stream.match(/\|[^|]*\|/)) {
      return "string";
    }
    
    // Node shapes - text in brackets
    if (stream.match(/\[[^\]]*\]/)) {
      return "variableName.definition";
    }
    
    // Node shapes - rounded
    if (stream.match(/\([^)]*\)/)) {
      return "variableName.definition";
    }
    
    // Node shapes - diamond
    if (stream.match(/\{[^}]*\}/)) {
      return "variableName.definition";
    }
    
    // Database nodes
    if (stream.match(/\[\([^\)]*\)\]/)) {
      return "typeName";
    }
    
    // Circle nodes
    if (stream.match(/\(\([^)]*\)\)/)) {
      return "typeName";
    }
    
    // Strings in quotes
    if (stream.match(/"[^"]*"/)) {
      return "string";
    }
    if (stream.match(/'[^']*'/)) {
      return "string";
    }
    
    // Numbers (for coordinates, dates)
    if (stream.match(/\d{4}-\d{2}-\d{2}/)) {
      return "number";
    }
    if (stream.match(/\d+(\.\d+)?/)) {
      return "number";
    }
    
    // Identifiers (node IDs)
    if (stream.match(/[A-Za-z_][A-Za-z0-9_]*/)) {
      return "variableName";
    }
    
    // Colon for messages/labels
    if (stream.match(/:/)) {
      return "punctuation";
    }
    
    // Skip other characters
    stream.next();
    return null;
  }
});

export default dslLanguage;
